import SingleRoomUpsells from './SingleRoomUpsells';

export default SingleRoomUpsells;
